import { useNavigate } from "react-router-dom";
import { HeartCrack } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0a0e17] grid place-items-center px-4">
      <div data-testid="payment-cancel-page" className="max-w-md w-full text-center rounded-2xl border border-slate-800 bg-slate-950 p-10">
        <HeartCrack className="mx-auto text-slate-500" size={52} />
        <h1 className="font-display text-2xl font-bold mt-5 text-slate-50">Pagamento annullato</h1>
        <p className="text-slate-400 mt-2 text-sm">Nessun addebito effettuato. I tuoi pixel sono ancora disponibili sul muro.</p>
        <Button data-testid="back-to-wall-button" onClick={() => navigate("/")}
          className="mt-6 bg-rose-600 hover:bg-rose-500 rounded-full h-12 px-8 font-semibold">
          Torna al muro
        </Button>
      </div>
    </div>
  );
}
